import { render, staticRenderFns } from "./ModalEnvioDocumentosSei.vue?vue&type=template&id=e4ae1c64&"
import script from "./ModalEnvioDocumentosSei.vue?vue&type=script&lang=js&"
export * from "./ModalEnvioDocumentosSei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports